const ERROR_MESSAGES: Record<string, string> = {
  LEAVE_TYPE_NOT_FOUND: 'Loại nghỉ phép không tồn tại.',
  LEAVE_TYPE_INACTIVE: 'Loại nghỉ phép đã bị tắt.',
  LEAVE_TYPE_NAME_EXISTS: 'Tên loại nghỉ phép đã tồn tại.',
  LEAVE_APPROVER_NOT_FOUND: 'Người duyệt không tồn tại.',
  LEAVE_APPROVER_INVALID_ROLE: 'Người duyệt phải là Admin hoặc Mod.',
  LEAVE_DATE_INVALID: 'Ngày nghỉ phép không hợp lệ.',
  LEAVE_DATES_REQUIRED: 'Vui lòng chọn ít nhất một ngày nghỉ.',
  LEAVE_REQUEST_OVERLAP: 'Nhân viên đã có phiếu nghỉ trong ngày đã chọn.',
  LEAVE_REQUEST_NOT_FOUND: 'Phiếu nghỉ phép không tồn tại.',
  LEAVE_REQUEST_NOT_PENDING: 'Phiếu này đã được xử lý trước đó.',
  LEAVE_REQUEST_CANNOT_SELF_APPROVE: 'Không thể tự duyệt phiếu của chính mình.',
  LEAVE_REQUEST_CANNOT_CANCEL: 'Chỉ có thể hủy phiếu đang chờ duyệt.',
};

const CODE_LIKE = /^[A-Z][A-Z0-9_]{3,}$/;

interface Options {
  raceCondition?: boolean;
}

export function mapLeaveRequestError(err: any, options: Options = {}): string {
  const status: number | undefined = err?.statusCode || err?.status;
  const raw: string | undefined = Array.isArray(err?.message)
    ? err.message[0]
    : err?.message || err?.error;

  if (options.raceCondition && raw?.includes('LEAVE_REQUEST_NOT_PENDING')) {
    return 'Phiếu đã được xử lý bởi người khác.';
  }

  for (const [code, message] of Object.entries(ERROR_MESSAGES)) {
    if (raw?.includes(code)) return message;
  }

  // Mã chưa có trong bảng, vd. 409 APPROVAL_ROLE_NOT_ALLOWED của luật quyền: máy chủ gửi kèm câu
  // tiếng Việt ở `error`, hiện câu đó thay cho mã trơn.
  const serverText = typeof err?.error === 'string' ? err.error.trim() : '';
  if (raw && CODE_LIKE.test(raw) && serverText && !CODE_LIKE.test(serverText)) return serverText;

  if (raw === 'Forbidden' || status === 403) return 'Bạn không có quyền thực hiện thao tác này.';
  if (raw === 'Unauthorized' || status === 401) return 'Phiên đăng nhập đã hết hạn.';
  if (status && status >= 500) return 'Lỗi server. Vui lòng thử lại sau.';
  return raw || 'Có lỗi xảy ra. Vui lòng thử lại.';
}

export function hasLeaveRequestErrorCode(err: any, code: string): boolean {
  const raw: string | undefined = Array.isArray(err?.message)
    ? err.message.join(',')
    : err?.message || err?.error;
  return !!raw?.includes(code);
}
